import React from 'react';
import { CardStack } from '../CardStack';
import { cn } from '../utils/cn'; 

export function CardStackDemo() {
  return (
    <div className="h-[40rem] flex items-center justify-center w-full text-xs">
      <CardStack items={CARDS} />
    </div>
  );
}

export const Highlight = ({ children, className }) => {
  return (
    <span
      className={cn(
        "font-bold text-emerald-700 bg-transparent px-1 py-0.5 text-xs",
        className
      )}
    >
      {children}
    </span>
  );
};

const CARDS = [
  {
    id: 0,
    name: "Manu Arora",
    designation: "Senior Software Engineer",
    content: (
      <p>
        I recommend all technologies used here, <Highlight>Perfonally I use them all the time</Highlight> in my projects. Don't doubt to contract the services provided here... 🙏
      </p>
    ),
  },
  {
    id: 1,
    name: "Mr Chunk",
    designation: "Senior Ethical Hacker",
    content: (
      <p>
        I don't contract external services for ecommerce, <Highlight>I prefer to build an independant one as Nala offers</Highlight> because It gives you freedom.<Highlight>My company stand out for companies like this one.</Highlight>
      </p>
    ),
  },
  {
    id: 2,
    name: "Tyler Durden",
    designation: "Manager Project Mayhem",
    content: (
      <p>
        The first rule of <Highlight>Creativity</Highlight> is that you feel the fresh to star your oun stuff<Highlight>With free frmeworks</Highlight> your potential will be boosted, go Ahed with Nala.
      </p>
    ),
  },
];
